/* @flow */

import config from './getRiskConfig';

const getRiskLevel = (risk: number, coeffBar: Object) => {
  const { forceLiquidationBar = 1.1, normalBar = 1.5, marginCallBar = 1.3 } = coeffBar;
  const leftBoundary = normalBar * 1.2;
  let edge = -60;
  let level = 'lowRisk';
  switch (true) {
    case risk >= leftBoundary:
      edge = -60;
      break;
    case risk >= normalBar && risk < leftBoundary:
      edge = -60 + 40 * (leftBoundary - risk) / (normalBar * 0.2);
      break;
    case risk >= marginCallBar && risk < normalBar:
      edge = -20 + 40 * (normalBar - risk) / (normalBar - marginCallBar);
      level = 'moderateRisk';
      break;
    case risk >= forceLiquidationBar && risk < marginCallBar:
      edge = 20 + 40 * (marginCallBar - risk) / (marginCallBar - forceLiquidationBar);
      level = 'highRisk';
      break;
    default:
      edge = 60;
      level = 'forcedLiquidation';
  }
  const { color, tip } = config[level];
  return {
    edge,
    riskLevel: level,
    color,
    tip,
  };
};

export { getRiskLevel as default };
